export const LEAGUE_CONFIGS = {
  epl: {
    playerHeadshot: (externalRef, teamExternalRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${externalRef}_${teamExternalRef}.png`,
    teamLogo: (logoRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${logoRef}.png`,
    playerFileName: (externalRef, teamExternalRef) =>
      `${externalRef}_${teamExternalRef}.png`,
    teamFileName: (logoRef) => `${logoRef}.png`,
  },
  ligue1: {
    playerHeadshot: (externalRef, teamExternalRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${externalRef}_${teamExternalRef}.png`,
    teamLogo: (logoRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${logoRef}.png`,
    playerFileName: (externalRef, teamExternalRef) =>
      `${externalRef}_${teamExternalRef}.png`,
    teamFileName: (logoRef) => `${logoRef}.png`,
  },
  bet365: {
    playerHeadshot: (externalRef, teamExternalRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${externalRef}_${teamExternalRef}.png`,
    teamLogo: (logoRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${logoRef}.png`,
    playerFileName: (externalRef, teamExternalRef) =>
      `${externalRef}_${teamExternalRef}.png`,
    teamFileName: (logoRef) => `${logoRef}.png`,
  },
  ncaaf: {
    playerHeadshot: (externalRef, teamExternalRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${externalRef}_${teamExternalRef}.png`,
    teamLogo: (logoRef) =>
      `${process.env.REACT_APP_STORAGE_URL}/headshots/${logoRef}.png`,
    playerFileName: (externalRef, teamExternalRef) =>
      `${externalRef}_${teamExternalRef}.png`,
    teamFileName: (logoRef) => `${logoRef}.png`,
  },
  default: {
    playerHeadshot: (externalRef) =>
      `https://assets.nhle.com/mugs/nhl/latest/${externalRef}.png`,
    teamLogo: (logoRef) =>
      `https://assets.nhle.com/logos/nhl/svg/${logoRef}_light.svg`,
    playerFileName: (externalRef) => `${externalRef}.png`,
    teamFileName: (logoRef) => `${logoRef}.png`,
  },
};
export const SCORING_BREAKDOWN_CONFIG = process.env.REACT_APP_LEAGUE_NAME === 'nhl'
  ? [
    "goal",
    "assist",
    "shotOnTarget",
    "hockeyHit",
    "hockeyBlockedShot",
    "teamWin",
    "hockeyTeamPowerPlayGoal",
    "hockeyTeamShortHandedGoal",
    "teamGoalAgainst",
    "teamCleanSheet",
    "teamSave",
  ]
  : [
    "goal",
    "assist",
    "shotOnTarget",
    "tackleWon",
    "cleanSheet",
    "passIntercepted",
    "teamWin",
    "teamGoalAgainst",
    "teamCleanSheet",
    "teamSave",
    "teamCorner",
    "matchPlayed",
  ];

